import { httpClient } from '@/services/http/httpClient'

type CreateTagProps = {
  name: string
  portfolioId: string
  textColor: string
  color: string
}

export const createTag = async (data: CreateTagProps) => {
  const { data: response } = await httpClient.post(
    '/projects/portfolio-tags',
    data,
  )
  return response
}
